import {GlobalError} from './GlobalError';

const isGlobalError = (error: any): error is GlobalError =>
  typeof error === 'object' && error !== null && typeof error.kind === 'symbol';

export default isGlobalError;
